import { SolutionsGovernmentView } from "~landing/views/solutions/government";
import { NextPage } from "next";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { useEffect } from "react";
import { sendLandingPageViewEvent } from "~tag-manager/send-event";

const SolutionsGovernmentPage: NextPage = () => {
	useEffect(() => {
		sendLandingPageViewEvent({ icp: "government" });
	}, []);

	return (
		<>
			<MarketingSeo
				path="/solutions/government"
				title="Online GIS for local government"
				description="Create and securely share maps your way. The accessible and user-friendly alternative to Esri for smart spenders."
			/>
			<SolutionsGovernmentView />
		</>
	);
};

export default SolutionsGovernmentPage;
